import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategorySidebar({ activeSlug }: { activeSlug: string }) {
  const hot = [...articles]
    .filter((a) => a.hotRank)
    .sort((a, b) => (a.hotRank as number) - (b.hotRank as number))
    .slice(0, 5);

  return (
    <aside className="lg:col-span-4 space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-100 p-6">
        <h3 className="font-heading font-bold text-base text-foreground-950 mb-4">其他栏目</h3>
        <ul className="space-y-1.5">
          {categories.map((c) => (
            <li key={c.slug}>
              <Link
                to={`/category/${c.slug}`}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                  c.slug === activeSlug
                    ? 'bg-primary-100 text-primary-800 font-medium'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                <i className={c.icon}></i>
                {c.name}
                <i className="ri-arrow-right-s-line ml-auto text-foreground-400"></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-6">
        <h3 className="font-heading font-bold text-base text-foreground-950 mb-4 flex items-center gap-2">
          <i className="ri-fire-line text-accent-600"></i>
          全站热榜
        </h3>
        <ol className="space-y-3.5">
          {hot.map((a, i) => (
            <li key={a.id} className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded flex items-center justify-center text-xs font-heading font-bold bg-background-200 text-foreground-700">
                {i + 1}
              </span>
              <Link
                to={`/article/${a.id}`}
                className="text-sm text-foreground-800 leading-snug hover:text-primary-700 transition-colors cursor-pointer line-clamp-2"
              >
                {a.title}
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-accent-200 bg-accent-50 p-6">
        <h3 className="font-heading font-bold text-base text-foreground-950">手上有料？</h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
          匿名投稿你掌握的第一手信息，编辑会交叉核实后整理发布。
        </p>
        <Link
          to="/contact"
          className="mt-4 inline-flex items-center gap-2 h-10 px-4 rounded-md bg-accent-600 text-background-50 text-sm font-medium hover:bg-accent-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-send-plane-line"></i>
          我要爆料
        </Link>
      </div>
    </aside>
  );
}